<script>

import { ref , onMounted } from 'vue'

export default {

    props : [ 'value' ] ,
    setup( props ){

        const inputAddress = ref( null );

        onMounted(
            () => {
                ymaps.ready(
                    () => {
                        let suggest = new ymaps.SuggestView( inputAddress.value );
                        suggest.events.add( [ 'select' ] , ( event ) => props.value.data.address = event.get( 'item' ).value )
                    }
                );
            }
        );

        function setAddress( data ){
            props.value.data = { address : data };
        }

        return {
            props ,
            inputAddress
        }
    }
}

</script>

<template>
    <div class="title">
        Введите адрес доставки
    </div>
    <input
        type="text"
        class="input"
        ref="inputAddress"
        v-model="props.value.data.address"
    >
</template>

<style scoped>
.title {
    margin-top: 20px;
}
</style>
